export const IDLE_TIMEOUT_MS = 4 * 60 * 60 * 1000;
export const WARNING_BEFORE_MS = 60 * 1000;
export const LAST_ACTIVITY_KEY = 'lastActivity';
